import React from 'react';

export const TextField = ({ label, value, onChange, testid, ...rest }) => (
    <div>
        <label className="label-caps text-white/60 block mb-2">{label}</label>
        <input value={value ?? ''} onChange={(e) => onChange(e.target.value)} className="w-full bg-brand-bg border border-white/10 focus:border-brand-primary transition-colors text-white p-3 outline-none disabled:opacity-50" data-testid={testid} {...rest} />
    </div>
);

export const TextArea = ({ label, value, onChange, testid, rows = 4 }) => (
    <div>
        <label className="label-caps text-white/60 block mb-2">{label}</label>
        <textarea rows={rows} value={value ?? ''} onChange={(e) => onChange(e.target.value)} className="w-full bg-brand-bg border border-white/10 focus:border-brand-primary transition-colors text-white p-3 outline-none" data-testid={testid} />
    </div>
);

export const SelectField = ({ label, value, onChange, options, testid }) => (
    <div>
        <label className="label-caps text-white/60 block mb-2">{label}</label>
        <select value={value} onChange={(e) => onChange(e.target.value)} className="w-full bg-brand-bg border border-white/10 focus:border-brand-primary transition-colors text-white p-3 outline-none" data-testid={testid}>
            {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
    </div>
);

export const Check = ({ label, checked, onChange, testid }) => (
    <label className="label-caps text-white/70 flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
        {label}
    </label>
);

